import { isEmpty, mapValues, pick, trim } from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { isValidPhone } from '../../Lib/Utils/FormUtils/vendor-application';
import validateEmail from '../../Lib/Utils/Helpers/validate-email';
import TextInput from '../ReusableComponents/TextInput/TextInput';

export default function CompanyFields(props) {
  const [form, setForm] = useState(
    pick(props.form, ['phone', 'email', 'remittance_advice_email']),
  );
  const [errors, setErrors] = useState(mapValues(form, () => false));

  const validator = {
    phone: (value) => isValidPhone(value, isEmpty(value)),
    email: (value) => isEmpty(value) || !validateEmail(value),
    remittance_advice_email: (value) => isEmpty(value) || !validateEmail(value),
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: trim(value) }));
  };

  const onBlur = (e) => {
    const { name, value } = e.target;
    props.onChange(name, form[name]);

    const fieldValidation = validator[name](value);
    setErrors((err) => ({ ...err, [name]: fieldValidation }));
    props.onErrorUpdate(name, fieldValidation ? 'error' : null);
  };

  return (
    <div className="flex flex-col md:flex-row gap-4">
      <TextInput
        fullWidth
        required
        error={errors.phone}
        disabled={props.disabled}
        label="Phone Number"
        variant="outlined"
        onChange={onChange}
        onBlur={onBlur}
        name="phone"
        value={form.phone || ''}
        id="va-phone"
        autoComplete="no"
      />
      <TextInput
        fullWidth
        required
        disabled={props.disabled}
        label="Email"
        variant="outlined"
        error={errors.email}
        onChange={onChange}
        onBlur={onBlur}
        name="email"
        value={form.email || ''}
        id="va-email"
        autoComplete="no"
      />
      <TextInput
        fullWidth
        required
        disabled={props.disabled}
        label="Payment Notification Email"
        variant="outlined"
        error={errors.remittance_advice_email}
        onChange={onChange}
        onBlur={onBlur}
        name="remittance_advice_email"
        value={form.remittance_advice_email || ''}
        id="va-email-remittance"
        autoComplete="no"
      />
    </div>
  );
}

CompanyFields.propTypes = {
  disabled: PropTypes.bool.isRequired,
  form: PropTypes.shape({
    phone: PropTypes.string,
    email: PropTypes.string,
    remittance_advice_email: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onErrorUpdate: PropTypes.func.isRequired,
};
